import Config from '../app.config'

export default class Viewport {

    /**
     *Creates an instance of Viewport.
     * @memberof Viewport
     */
    constructor() {
        this.breakpoints = Config.cssBreakpoints
    }

    /**
     * Gets the window height.
     *
     * @readonly
     * @memberof Viewport
     */
    get height() {
        return window.innerHeight || document.documentElement.clientHeight
    }

    /**
     * Gets the window width
     *
     * @readonly
     * @memberof Viewport
     */
    get width() {
        return window.innerWidth || document.documentElement.clientWidth
    }

    /**
     * Executes the provided function only where the width exceeds the small viewport size.
     *
     * @param {Function} func
     * @memberof Viewport
     */
    bpMinSmall(func) {
        if (this.width < this.breakpoints.$small) return
        func()
    }

    /**
     * Executes the provided function only where the width exceeds the mid viewport size.
     *
     * @param {Function} func
     * @memberof Viewport
     */
    bpMinMid(func) {
        if (this.width < this.breakpoints.$mid) return
        func()
    }

    /**
     * Executes the provided function only where the width exceeds the wide viewport size.
     *
     * @param {Function} func
     * @memberof Viewport
     */
    bpMinWide(func) {
        if (this.width < this.breakpoints.$wide) return
        func()
    }

    /**
     * Executes the provided function only where the width exceeds the wider viewport size.
     *
     * @param {Function} func
     * @memberof Viewport
     */
    bpMinWider(func) {
        if (this.width < this.breakpoints.$wider) return
        func()
    }

    /**
     * Executes the provided function only where the width exceeds the superwide viewport size.
     *
     * @param {Function} func
     * @memberof Viewport
     */
    bpMinSuperwide(func) {
        if (this.width < this.breakpoints.$superwide) return
        func()
    }
}
